import { ParcelQueryParams } from "./query.types";
import { SearchReferenceDTO } from "entities/shared/shipmentCard.types";
import { Nullable } from "shared/lib/typeCheck.lib";
import { t } from "shared/localization/localization";

export const piecesText = (pieces: number): string => {
  return `${pieces} ${pieces > 1 ? t("pieces") : t("piece")}`;
};

type CreateParcelSearchQueryParamsParams = {
  requestType: "openedCard" | "updateCard" | "search";
  override?: Partial<ParcelQueryParams>;
};

export const createParcelSearchQueryParams = ({
  requestType,
  override,
}: CreateParcelSearchQueryParamsParams): ParcelQueryParams | null => {
  const reference: Nullable<SearchReferenceDTO> = override?.number;
  const carrierCode: Nullable<SearchReferenceDTO> = override?.carrierCode;

  if (!reference) return null;

  switch (requestType) {
    case "openedCard":
      return Object.assign({
        number: reference,
        ...(carrierCode ? { carrier_code: carrierCode } : {}),
      });
    case "search":
    default:
      return Object.assign({
        number: reference,
        ...(carrierCode ? { carrier_code: carrierCode } : {}),
      });
  }
};
